module.exports = __webpack_public_path__ + "static/media/ford-aircraft-hi.9f731daa.png";